import { api, API } from "./api";

/**
 * Admin auth uses a Bearer token returned by /admin/login.
 *
 * IMPORTANT: We MUST NOT set `withCredentials: true` on admin requests.
 * The deployment proxy rewrites `Access-Control-Allow-Origin: *`, and browsers
 * refuse credentials with `*`. Using Authorization header instead works
 * everywhere because it doesn't require credentials mode.
 *
 * Storage: sessionStorage — cleared on tab close, same-origin only.
 * Server-side enforces 24h token TTL so a leaked token is short-lived.
 */
const TOKEN_KEY = "portal_admin_token";

export const getAdminToken = () => {
    try {
        return sessionStorage.getItem(TOKEN_KEY) || null;
    } catch (err) {
        console.warn("sessionStorage read failed:", err);
        return null;
    }
};

export const setAdminToken = (token) => {
    try {
        if (token) sessionStorage.setItem(TOKEN_KEY, token);
        else sessionStorage.removeItem(TOKEN_KEY);
    } catch (err) {
        console.warn("sessionStorage write failed:", err);
    }
};

export const clearAdminToken = () => setAdminToken(null);

// Attach Authorization header to every /admin/* request.
api.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.includes("/admin/")) {
        const t = getAdminToken();
        if (t) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${t}`;
        }
    }
    return config;
});

export const adminLogin = (username, password) =>
    api.post("/admin/login", { username, password }).then((r) => {
        if (r.data?.token) setAdminToken(r.data.token);
        return r.data;
    });

export const adminLogout = () =>
    api
        .post("/admin/logout", null)
        .then((r) => { clearAdminToken(); return r.data; })
        .catch((e) => { clearAdminToken(); throw e; });

export const adminMe = () => api.get("/admin/me").then((r) => r.data);

export const fetchPhase = () => api.get("/admin/phase").then((r) => r.data);
export const setPhase = (phase_state) =>
    api.post("/admin/phase", { phase_state }).then((r) => r.data);

export const fetchRewards = () => api.get("/reward-tokens").then((r) => r.data);
export const createReward = (data) =>
    api.post("/admin/reward-tokens", data).then((r) => r.data);
export const deleteReward = (id) =>
    api.delete(`/admin/reward-tokens/${id}`).then((r) => r.data);

export { API };
